import { ReactNode } from 'react';

export const ensureString = ({
    value,
    fallback = undefined,
}: {
    value: ReactNode;
    fallback?: string;
}): string | undefined => {
    return typeof value === 'string' ? value : fallback;
};
